import { tenant } from './tenant';

const {
    ENV: { 
        ILLINOIS,
        OKLAHOMA,
        ARKANSAS,
        ARKANSAS_GOV,
        WEST_VIRGINIA,
        MISSISSIPPI,
        SALES
    }
} = tenant;

const COMMON_PATHS = {
    LOCAL_HOST: {
        api: 'https://localhost:8181',
        app: 'https://localhost:9191'
    },
    // TODO: Remove commented code once deployment issue resolved
    // LOCAL_HOST: {
    //     api: 'https://dev.lnpweb.com', 
    //     app: 'https://dev.lnpweb.com' 
    // },
    TEST: {
        api: 'http://test',
        app: 'http://test'
    },
    PAGE_NOT_FOUND_PATH: '/404',
    CONSTITUENT_CREATE_ACCOUNT: '/authenticate/create-account?tenant={mspTenantId}',
    CONSTITUENT_VERIFY_ACCOUNT: '/authenticate/verify-account?tenant={mspTenantId}',
    CONSTITUENT_FORGOT_USERNAME: '/authenticate/forgot-username?tenant={mspTenantId}',
    CONSTITUENT_REDIRECT_SIGN_IN: '/authenticate/validate',
    CONSTITUENT_REDIRECT_SIGN_OUT: '/login',
    AGENCY_LOGIN: '/management?tenant={mspTenantId}',
    APPLICATION: '/authenticate/{vanityUrl}',
};

const RLP_PATHS = {
    RLP_QA: {
        api: 'https://qa.lnpweb.com', 
        app: 'https://qa.lnpweb.com' 
    },
    RLP_DEV: {
        api: 'https://dev.lnpweb.com', 
        app: 'https://dev.lnpweb.com' 
    },
    RLP_UAT: {
        api: 'https://uat.lnpweb.com',
        app: 'https://uat.lnpweb.com'
    },
    RLP_STG: {
        api: 'https://stg.lnpweb.com',
        app: 'https://stg.lnpweb.com'
    },
    RLP_PROD: {
        api: 'https://lnpweb.com',
        app: 'https://lnpweb.com'
    },
    RLP_TYLER_STG: {
        api: 'https://apps-stg.lnpweb.com',
        app: 'https://apps-stg.lnpweb.com'
    },
    RLP_TYLER_PROD: {
        api: 'https://apps.lnpweb.com',
        app: 'https://apps.lnpweb.com'
    },
    RLP_GOV_DEV: {
        api: 'https://dev.elp.egov.com',
        app: 'https://dev.elp.egov.com'
    },
    RLP_GOV_STG: {
        api: 'https://stg.elp.egov.com',
        app: 'https://stg.elp.egov.com'
    },
    RLP_GOV_PROD: {
        api: 'https://apps.elp.egov.com',
        app: 'https://apps.elp.egov.com'
    }
};

const ILLINOIS_PATHS = {
    [ILLINOIS.DEV]: RLP_PATHS.RLP_DEV,
    [ILLINOIS.QA]: RLP_PATHS.RLP_QA,
    [ILLINOIS.UAT]: RLP_PATHS.RLP_UAT,
    [ILLINOIS.STG]: RLP_PATHS.RLP_STG,
    [ILLINOIS.PROD]: RLP_PATHS.RLP_PROD
};

const OKLAHOMA_PATHS = {
    [OKLAHOMA.DEV]: RLP_PATHS.RLP_DEV
};

const ARKANSAS_PATHS = {
    [ARKANSAS.STG]: RLP_PATHS.RLP_TYLER_STG,
    [ARKANSAS.PROD]: RLP_PATHS.RLP_TYLER_PROD
};

const ARKANSAS_GOV_PATHS = {
    [ARKANSAS_GOV.DEV]: RLP_PATHS.RLP_GOV_DEV,
    [ARKANSAS_GOV.STG]: RLP_PATHS.RLP_GOV_STG,
    [ARKANSAS_GOV.PROD]: RLP_PATHS.RLP_GOV_PROD
};

const WEST_VIRGINIA_PATHS = {
    [WEST_VIRGINIA.STG]: RLP_PATHS.RLP_TYLER_STG,
    [WEST_VIRGINIA.PROD]: RLP_PATHS.RLP_TYLER_PROD
};

const MISSISSIPPI_PATHS = {
    [MISSISSIPPI.STG]: RLP_PATHS.RLP_TYLER_STG,
    [MISSISSIPPI.PROD]: RLP_PATHS.RLP_TYLER_PROD
};

const SALES_PATHS = {
    [SALES.STG]: RLP_PATHS.RLP_TYLER_STG
};

// Separate gov cloud paths to avoid key collisions
const GOV_CLOUD_PATHS = {
    ...ARKANSAS_GOV_PATHS
};

export const path = {
    ...COMMON_PATHS,
    ...RLP_PATHS,
    ...ILLINOIS_PATHS,
    ...OKLAHOMA_PATHS,
    ...ARKANSAS_PATHS,
    ...WEST_VIRGINIA_PATHS,
    ...MISSISSIPPI_PATHS,
    ...SALES_PATHS,
    GOV_CLOUD_PATHS
};



// WEBPACK FOOTER //
// ./src/common/constants/path.js